import { HttpClient } from '@angular/common/http';
import { Provider } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { CMPS_APP_CONFIG } from '../../app.config';
import { AuthService } from '../../auth/auth.service';
import { PeopleOfInterestUserService } from '../../user/people-of-interest.user.service';
import { UserService } from '../../user/user.service';

import { OldCoachingInsightWidgetService } from './services/coaching-insight.widget.service';
import { OldCoachingService } from './services/coaching.service';
import { OldElasticUIService } from './services/elastic-ui.service';
import { OldFrontlineOAService } from './services/frontline-oa.service';
import { OldPersonOfInterestService } from './services/person-of-interest.service';
import { OldTeamOAService } from './services/team-oa.service';

export const OldOaProviders: Provider[] = [
    {
        provide: OldCoachingInsightWidgetService,
        useClass: OldCoachingInsightWidgetService,
        deps: [
            HttpClient,
            Router,
            AuthService,
            UserService,
            OldTeamOAService,
            OldFrontlineOAService,
            CMPS_APP_CONFIG,
        ],
    },
    {
        provide: OldTeamOAService,
        useClass: OldTeamOAService,
        deps: [HttpClient, CMPS_APP_CONFIG, UserService, TranslateService],
    },
    {
        provide: OldFrontlineOAService,
        useClass: OldFrontlineOAService,
        deps: [HttpClient, CMPS_APP_CONFIG, TranslateService],
    },
    {
        provide: OldCoachingService,
        useClass: OldCoachingService,
        deps: [HttpClient, Router, CMPS_APP_CONFIG],
    },
    {
        provide: OldPersonOfInterestService,
        useClass: OldPersonOfInterestService,
        deps: [
            HttpClient,
            CMPS_APP_CONFIG,
            AuthService,
            PeopleOfInterestUserService,
        ],
    },
    {
        provide: OldElasticUIService,
        useClass: OldElasticUIService,
        deps: [],
    },
];
